import { render, staticRenderFns } from "./paymentConfirm.vue?vue&type=template&id=32bef38a&scoped=true"
import script from "./paymentConfirm.vue?vue&type=script&lang=js"
export * from "./paymentConfirm.vue?vue&type=script&lang=js"
import style0 from "./paymentConfirm.vue?vue&type=style&index=0&id=32bef38a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32bef38a",
  null
  
)

export default component.exports